export type UserRole = 'SUPER_ADMIN' | 'CLUB_ADMIN' | 'COACH' | 'STATISTICIAN' | 'PLAYER';

export interface StoredUser {
  id: string;
  email: string;
  name: string | null;
  role: UserRole;
  emailVerified: boolean;
  club?: {
    id: string;
    name: string;
    city: string | null;
  } | null;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  name?: string;
  invitationCode?: string;
}

export interface AuthState {
  user: StoredUser | null;
  isAuthenticated: boolean;
}

/**
 * Hiérarchie centrale des rôles applicatifs côté client.
 *
 * Doit rester synchronisée avec `Volley_Stats_Backend/src/common/utils/role-hierarchy.util.ts` :
 * un rôle de niveau N hérite des droits de tous les rôles de niveau < N.
 */
export const ROLE_HIERARCHY: Record<UserRole, number> = {
  SUPER_ADMIN: 5,
  CLUB_ADMIN: 4,
  COACH: 3,
  STATISTICIAN: 2,
  PLAYER: 1,
};

/**
 * Retourne `true` si `userRole` atteint au moins `requiredRole` selon la
 * hiérarchie. Utile en dehors du store `useAuthController`, par exemple dans
 * les composants ne dépendant pas du contexte d'authentification.
 */
export const hasRoleAtLeast = (userRole: UserRole, requiredRole: UserRole): boolean =>
  (ROLE_HIERARCHY[userRole] ?? 0) >= (ROLE_HIERARCHY[requiredRole] ?? 0);

